/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { DAI_ZERO_REVIEW_MUTATION_RESULT_FIELDS } from '../fragments'

export const UNVERIFY_DAI_ZERO_CROPS = gql`
  ${DAI_ZERO_REVIEW_MUTATION_RESULT_FIELDS}
  mutation UnverifyDAIZeroCrops($input: UnverifyDAIZeroCropsInput!) {
    unverifyDaiZeroCrops(input: $input) {
      ...DAIZeroReviewMutationResultFields
    }
  }
`
